// extracted by mini-css-extract-plugin
export var pillWrapper = "_on-0";
export var showOverflow = "_on-1";